const rtl = document.getElementsByTagName('html')[0].getAttribute('dir')
const withDirection = Component => Component

export default withDirection
export { rtl }
